import dynamic from 'next/dynamic'
import { BlockProps } from '../BlockProps'

export const DynamicHappyCustomersMapBlock = dynamic<BlockProps>(() =>
  import('./HappyCustomersMapBlock').then((md) => md.HappyCustomersMapBlock)
)
